// One unified, rich dataset for every destination shown on the Destinations page.
// Each destination has the data needed to render both the card AND the detail page.

const IMG = {
  shillong: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&q=80",
  sohra: "https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=1600&q=80",
  dawki: "https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=1600&q=80",
  mawlynnong: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=1600&q=80",
  laitlum: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1600&q=80",
  nongriat: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1600&q=80",
  krangsuri: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1600&q=80",
  weisawdong: "https://images.unsplash.com/photo-1429277096327-11ee3b35e7d4?w=1600&q=80",
  rootbridge: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=1600&q=80",
  cave: "https://images.unsplash.com/photo-1455218873509-8097305ee378?w=1600&q=80",
  forest: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=80",
  kaziranga: "https://images.unsplash.com/photo-1549366021-9f761d450615?w=1600&q=80",
  majuli: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1600&q=80",
  guwahati: "https://images.unsplash.com/photo-1602020277972-fd160de66021?w=1600&q=80",
  pobitora: "https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?w=1600&q=80",
  manas: "https://images.unsplash.com/photo-1535338454770-8be927b5a00b?w=1600&q=80",
  sivasagar: "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=1600&q=80",
  haflong: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1600&q=80",
  tawang: "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=1600&q=80",
  bomdila: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1600&q=80",
  dirang: "https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=1600&q=80",
  ziro: "https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=1600&q=80",
  mechuka: "https://images.unsplash.com/photo-1518627005462-a3eb2cd34504?w=1600&q=80",
  selapass: "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=1600&q=80",
  namdapha: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1600&q=80",
  lake: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1600&q=80",
  market: "https://images.unsplash.com/photo-1519817650390-64a93db51149?w=1600&q=80",
  monastery: "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=1600&q=80",
  kamakhya: "https://images.unsplash.com/photo-1602020277972-fd160de66021?w=1600&q=80",
  river: "https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=1600&q=80",
  hills: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1600&q=80",
};

const baseFaqs = (name) => [
  { q: `Is ${name} good for first-time travellers?`, a: `Yes. ${name} is well connected and our team handles permits, transport and bookings end-to-end.` },
  { q: `What is the best way to reach ${name}?`, a: `Private SUV from Guwahati or Shillong is the most comfortable option. We arrange airport pickup on every package.` },
];

// Convenience helper to keep entries compact.
const D = (o) => ({
  duration: "Half – 1 Day",
  faqs: baseFaqs(o.name),
  packageIds: ["meg-3", "meg-5"],
  ...o,
});

export const DESTINATIONS = [
  // ============ MEGHALAYA ============
  D({
    slug: "shillong", name: "Shillong", state: "Meghalaya", hero: IMG.shillong, price: 6999,
    blurb: "The Scotland of the East — pine-clad hills, cafés on cobbled lanes and live music spilling onto Khasi sidewalks.",
    best: "March – June, September – November", duration: "2 Days",
    attractions: ["Ward's Lake", "Police Bazaar", "Don Bosco Museum", "Cathedral of Mary Help of Christians", "Lady Hydari Park"],
    todo: ["Café-hop on Laitumkhrah", "Catch a live gig", "Sunset at Shillong Peak", "Boating at Ward's Lake", "Khasi food trail"],
    itinerary: [
      { day: 1, title: "Arrival & city soul", desc: "Airport pickup, check-in, Ward's Lake stroll, dinner at Café Shillong." },
      { day: 2, title: "Views & cafés", desc: "Shillong Peak at dawn, Elephant Falls, Don Bosco Museum, Laitumkhrah café trail." },
    ],
    nearby: ["Cherrapunji", "Mawphlang Sacred Forest", "Umiam Lake"],
    gallery: [IMG.shillong, IMG.lake, IMG.market, IMG.forest, IMG.hills],
    mapQuery: "Shillong, Meghalaya, India",
  }),
  D({
    slug: "cherrapunji", name: "Cherrapunji (Sohra)", state: "Meghalaya", hero: IMG.sohra, price: 8499,
    blurb: "Once the wettest place on Earth — plunging waterfalls, emerald gorges and skies that shift from monsoon to crystal in a single hour.",
    best: "October – May", duration: "1 – 2 Days",
    attractions: ["Nohkalikai Falls", "Mawsmai Cave", "Seven Sisters Falls", "Arwah Cave", "Eco Park"],
    todo: ["Trek to viewpoints", "Cave walks", "Photograph the falls", "Visit Khasi villages", "Try local Sohra cuisine"],
    itinerary: [
      { day: 1, title: "Falls and gorges", desc: "Drive in from Shillong, Nohkalikai, Seven Sisters, Mawsmai cave." },
      { day: 2, title: "Hidden Sohra", desc: "Arwah cave, Eco Park, Khoh Ramhah pillar rock, return to Shillong." },
    ],
    nearby: ["Mawlynnong", "Nongriat", "Dawki"],
    gallery: [IMG.sohra, IMG.weisawdong, IMG.rootbridge, IMG.cave, IMG.hills],
    mapQuery: "Cherrapunji, Meghalaya, India",
  }),
  D({
    slug: "dawki", name: "Dawki", state: "Meghalaya", hero: IMG.dawki, price: 7499,
    blurb: "The Umngot river so clear that boats appear to float on glass — and the quietest stretch of the India–Bangladesh border.",
    best: "November – April", duration: "1 Day",
    attractions: ["Umngot river boating", "India-Bangladesh border", "Bophill Falls", "Tamabil viewpoint"],
    todo: ["Crystal river boating", "Picnic by the river", "Border-line photo stop", "Visit Shnongpdeng for camping"],
    itinerary: [
      { day: 1, title: "Crystal river day", desc: "Early drive from Cherrapunji, Umngot boating, lunch by the river, border viewpoint, return." },
    ],
    nearby: ["Shnongpdeng", "Mawlynnong", "Krang Suri"],
    gallery: [IMG.dawki, IMG.river, IMG.krangsuri, IMG.hills, IMG.forest],
    mapQuery: "Dawki, Meghalaya, India",
  }),
  D({
    slug: "shnongpdeng", name: "Shnongpdeng", state: "Meghalaya", hero: IMG.river, price: 7999,
    blurb: "Dawki's quieter upstream sibling — riverside tents, zip-lines and the same impossibly clear Umngot.",
    best: "November – April", duration: "1 – 2 Days",
    attractions: ["Riverside camping", "Cliff jumping", "Zip-line", "Snorkelling stretch"],
    todo: ["Sleep in a riverside tent", "Cliff jump into the Umngot", "Kayak / scuba try-dive", "Bonfire dinner"],
    itinerary: [
      { day: 1, title: "Slow river day", desc: "Drive in by lunch, swim, kayak, sunset cliff jump, bonfire." },
      { day: 2, title: "Adventure stack", desc: "Zip-line, snorkel session, breakfast by the river, return." },
    ],
    nearby: ["Dawki", "Krang Suri", "Mawlynnong"],
    gallery: [IMG.river, IMG.dawki, IMG.krangsuri, IMG.forest, IMG.hills],
    mapQuery: "Shnongpdeng, Meghalaya, India",
  }),
  D({
    slug: "mawlynnong", name: "Mawlynnong", state: "Meghalaya", hero: IMG.mawlynnong, price: 6499,
    blurb: "Asia's cleanest village — bamboo skywalks, orchid gardens and a single-root bridge a short hike away.",
    best: "October – May", duration: "1 Day",
    attractions: ["Bamboo Skywalk", "Balancing Rock", "Single Root Bridge", "Church of the Epiphany"],
    todo: ["Climb the skywalk", "Village walk", "Photograph orchids", "Home-cooked Khasi lunch"],
    itinerary: [
      { day: 1, title: "Village & skywalk", desc: "Drive from Cherrapunji, village walk, bamboo skywalk, Khasi lunch, balancing rock." },
    ],
    nearby: ["Dawki", "Riwai Root Bridge", "Cherrapunji"],
    gallery: [IMG.mawlynnong, IMG.rootbridge, IMG.forest, IMG.hills, IMG.dawki],
    mapQuery: "Mawlynnong, Meghalaya, India",
  }),
  D({
    slug: "laitlum", name: "Laitlum Canyons", state: "Meghalaya", hero: IMG.laitlum, price: 4999,
    blurb: "An end-of-the-world ridge an hour from Shillong — hanging valleys, clouds at your feet and almost no crowds.",
    best: "September – May", duration: "Half Day",
    attractions: ["Laitlum viewpoint", "Trek to Rasong village", "Cloud meadows"],
    todo: ["Sunrise photography", "Short trek down to Rasong", "Picnic on the ridge"],
    itinerary: [
      { day: 1, title: "Ridge morning", desc: "Pre-dawn drive from Shillong, sunrise on the ridge, short trek, late breakfast in town." },
    ],
    nearby: ["Shillong", "Mawphlang", "Smit"],
    gallery: [IMG.laitlum, IMG.hills, IMG.forest, IMG.shillong],
    mapQuery: "Laitlum Canyons, Meghalaya, India",
  }),
  D({
    slug: "nongriat", name: "Nongriat", state: "Meghalaya", hero: IMG.nongriat, price: 9999,
    blurb: "3,500 stone steps down to the legendary double-decker root bridge, Rainbow Falls and natural turquoise pools.",
    best: "October – May", duration: "1 – 2 Days",
    attractions: ["Double Decker Root Bridge", "Rainbow Falls", "Natural pools", "Long single root bridge"],
    todo: ["The 3500-step trek", "Swim in the pools", "Stay in a village homestay", "Rainbow Falls hike"],
    itinerary: [
      { day: 1, title: "Trek down", desc: "Drive to Tyrna, trek down to Nongriat village, double-decker bridge, swim, homestay." },
      { day: 2, title: "Rainbow Falls", desc: "Early hike to Rainbow Falls, return trek up, drive back to Cherrapunji/Shillong." },
    ],
    nearby: ["Cherrapunji", "Tyrna", "Mawsmai"],
    gallery: [IMG.nongriat, IMG.rootbridge, IMG.weisawdong, IMG.forest, IMG.hills],
    mapQuery: "Nongriat, Meghalaya, India",
  }),
  D({
    slug: "double-decker-root-bridge", name: "Double Decker Living Root Bridge", state: "Meghalaya", hero: IMG.rootbridge, price: 9999,
    blurb: "A two-tier bridge woven from living ficus roots over generations — and one of the East's most photographed natural wonders.",
    best: "October – May", duration: "1 – 2 Days",
    attractions: ["The double-decker bridge", "Natural pools", "Rainbow Falls"],
    todo: ["Walk on a living bridge", "Swim in clear pools", "Photograph the ficus roots", "Meet the Khasi villagers"],
    itinerary: [
      { day: 1, title: "Into Nongriat", desc: "Drive to Tyrna, descend 3500 steps, the bridge by golden hour, homestay." },
      { day: 2, title: "Slow morning", desc: "Rainbow Falls hike, pools, climb back, return to Shillong." },
    ],
    nearby: ["Nongriat", "Cherrapunji", "Mawsmai"],
    gallery: [IMG.rootbridge, IMG.nongriat, IMG.weisawdong, IMG.forest, IMG.hills],
    mapQuery: "Double Decker Living Root Bridge, Nongriat, Meghalaya",
  }),
  D({
    slug: "wei-sawdong", name: "Wei Sawdong Falls", state: "Meghalaya", hero: IMG.weisawdong, price: 5499,
    blurb: "A three-tiered curtain falling into turquoise basins — accessed by a bamboo ladder hidden in the woods of Sohra.",
    best: "October – April", duration: "Half Day",
    attractions: ["Three-tier waterfall", "Turquoise pool", "Bamboo ladder descent"],
    todo: ["Climb down the bamboo ladder", "Swim in the pool", "Photograph the tiers"],
    itinerary: [
      { day: 1, title: "Falls morning", desc: "Drive from Cherrapunji, ladder descent, swim, picnic, return." },
    ],
    nearby: ["Cherrapunji", "Mawsmai", "Arwah Cave"],
    gallery: [IMG.weisawdong, IMG.sohra, IMG.hills, IMG.forest],
    mapQuery: "Wei Sawdong Falls, Cherrapunji, Meghalaya",
  }),
  D({
    slug: "krang-suri", name: "Krang Suri Falls", state: "Meghalaya", hero: IMG.krangsuri, price: 5999,
    blurb: "A sapphire pool fed by a curtain fall in the Jaintia Hills — the cleanest swim in Meghalaya, hands down.",
    best: "October – May", duration: "Half Day",
    attractions: ["Krang Suri waterfall", "Natural swim pool", "Jaintia village walk"],
    todo: ["Swim under the falls", "Cliff jumping", "Bamboo raft", "Photograph the blues"],
    itinerary: [
      { day: 1, title: "Jaintia day-trip", desc: "Drive from Shillong via Jowai, swim, picnic, sunset back in town." },
    ],
    nearby: ["Jowai", "Nartiang", "Dawki"],
    gallery: [IMG.krangsuri, IMG.river, IMG.weisawdong, IMG.hills, IMG.forest],
    mapQuery: "Krang Suri Falls, West Jaintia Hills, Meghalaya",
  }),
  D({
    slug: "nohkalikai-falls", name: "Nohkalikai Falls", state: "Meghalaya", hero: IMG.sohra, price: 5499,
    blurb: "India's tallest plunge waterfall — 1,115 ft of water falling straight into an emerald pool below Cherrapunji.",
    best: "September – December", duration: "Half Day",
    attractions: ["Main viewpoint", "Lower trek viewpoint", "Sunset deck"],
    todo: ["Photograph the plunge", "Walk to lower viewpoint", "Stay for sunset"],
    itinerary: [
      { day: 1, title: "Falls + Sohra", desc: "Drive from Shillong, Nohkalikai, Mawsmai, Seven Sisters, late return." },
    ],
    nearby: ["Cherrapunji", "Mawsmai", "Wei Sawdong"],
    gallery: [IMG.sohra, IMG.weisawdong, IMG.hills, IMG.forest, IMG.rootbridge],
    mapQuery: "Nohkalikai Falls, Cherrapunji, Meghalaya",
  }),
  D({
    slug: "mawphlang", name: "Mawphlang Sacred Forest", state: "Meghalaya", hero: IMG.forest, price: 4999,
    blurb: "A 1,000-year-old sacred grove the Khasi tribe protects with ritual law — nothing leaves the forest, not even a leaf.",
    best: "October – May", duration: "Half Day",
    attractions: ["Sacred grove walk", "Khasi heritage village", "Stone monoliths"],
    todo: ["Guided forest walk", "Learn Khasi traditions", "Photograph monoliths"],
    itinerary: [
      { day: 1, title: "Sacred half-day", desc: "Drive from Shillong, guided forest walk, lunch at the heritage village." },
    ],
    nearby: ["Shillong", "Smit", "Laitlum"],
    gallery: [IMG.forest, IMG.hills, IMG.shillong, IMG.laitlum],
    mapQuery: "Mawphlang Sacred Forest, Meghalaya",
  }),
  D({
    slug: "mawsynram", name: "Mawsynram", state: "Meghalaya", hero: IMG.sohra, price: 6999,
    blurb: "Officially the wettest place on Earth — moss-walled caves, mist forests and waterfalls that never stop.",
    best: "November – April", duration: "1 Day",
    attractions: ["Mawjymbuin Cave (Shivling)", "Mawsynram viewpoint", "Mossy forests"],
    todo: ["Cave walk", "Mist photography", "Visit the rain-village"],
    itinerary: [
      { day: 1, title: "Wet wonder", desc: "Drive from Cherrapunji, Mawjymbuin cave, viewpoint, return by evening." },
    ],
    nearby: ["Cherrapunji", "Mawphlang", "Shillong"],
    gallery: [IMG.sohra, IMG.cave, IMG.forest, IMG.hills],
    mapQuery: "Mawsynram, Meghalaya",
  }),
  D({
    slug: "garden-of-caves", name: "Garden of Caves", state: "Meghalaya", hero: IMG.cave, price: 4999,
    blurb: "A cluster of caves, waterfalls and rock pools tucked into the Khasi hills near Sohra — a complete morning of wonder.",
    best: "October – May", duration: "Half Day",
    attractions: ["Multiple linked caves", "Mini waterfalls", "Rock pools"],
    todo: ["Cave exploration", "Wade through pools", "Photography"],
    itinerary: [
      { day: 1, title: "Cave morning", desc: "Drive from Sohra, caves and pools, lunch, return." },
    ],
    nearby: ["Cherrapunji", "Wei Sawdong", "Arwah Cave"],
    gallery: [IMG.cave, IMG.weisawdong, IMG.hills, IMG.forest],
    mapQuery: "Garden of Caves, Laitmawsiang, Meghalaya",
  }),
  D({
    slug: "arwah-cave", name: "Arwah Cave", state: "Meghalaya", hero: IMG.cave, price: 4999,
    blurb: "Fossil-walled limestone tunnels in the Sohra plateau — one of Meghalaya's most accessible cave walks.",
    best: "October – May", duration: "Half Day",
    attractions: ["Marine fossils", "Stalactite chambers", "Forest entry walk"],
    todo: ["Guided cave walk", "Fossil spotting", "Photography"],
    itinerary: [
      { day: 1, title: "Caving morning", desc: "Drive from Cherrapunji, guided cave walk, lunch in Sohra." },
    ],
    nearby: ["Cherrapunji", "Mawsmai", "Garden of Caves"],
    gallery: [IMG.cave, IMG.sohra, IMG.hills, IMG.forest],
    mapQuery: "Arwah Cave, Cherrapunji, Meghalaya",
  }),
  D({
    slug: "krem-mawmluh", name: "Krem Mawmluh", state: "Meghalaya", hero: IMG.cave, price: 6999,
    blurb: "One of the world's longest caves — a UNESCO geological wonder cutting through the Sohra plateau.",
    best: "October – April", duration: "Half Day",
    attractions: ["River cave passages", "UNESCO geo-marker", "Rock formations"],
    todo: ["Guided spelunking", "River-cave walk", "Photography (advanced)"],
    itinerary: [
      { day: 1, title: "Caving day", desc: "Drive from Sohra, guided cave entry, river passage, lunch." },
    ],
    nearby: ["Cherrapunji", "Arwah Cave", "Mawsmai"],
    gallery: [IMG.cave, IMG.sohra, IMG.hills, IMG.forest],
    mapQuery: "Krem Mawmluh, Cherrapunji, Meghalaya",
  }),
  D({
    slug: "kongthong", name: "Kongthong", state: "Meghalaya", hero: IMG.hills, price: 7999,
    blurb: "The whistling village — every person here has a tune-name, sung instead of spoken across the valley.",
    best: "October – May", duration: "1 Day",
    attractions: ["Tune-name experience", "Khasi village walk", "Valley viewpoint"],
    todo: ["Meet tune-bearing villagers", "Forest walk", "Stay in a homestay"],
    itinerary: [
      { day: 1, title: "Village immersion", desc: "Drive from Shillong, village walk, tune demonstration, lunch with a family, return." },
    ],
    nearby: ["Sohra", "Smit", "Pynursla"],
    gallery: [IMG.hills, IMG.forest, IMG.shillong, IMG.mawlynnong],
    mapQuery: "Kongthong, East Khasi Hills, Meghalaya",
  }),
  D({
    slug: "umiam-lake", name: "Umiam Lake", state: "Meghalaya", hero: IMG.lake, price: 4499,
    blurb: "A 220-km² reservoir framed by pine ridges, just 15 minutes north of Shillong — kayak, sail or just watch the mist roll.",
    best: "All year", duration: "Half Day",
    attractions: ["Lakefront resorts", "Kayaking", "Sunset viewpoint"],
    todo: ["Kayak / paddle-board", "Sunset photography", "Lakeside lunch"],
    itinerary: [
      { day: 1, title: "Lake afternoon", desc: "Drive from Shillong, paddle session, sunset and lakeside dinner." },
    ],
    nearby: ["Shillong", "Nongpoh", "Smit"],
    gallery: [IMG.lake, IMG.shillong, IMG.hills, IMG.forest],
    mapQuery: "Umiam Lake, Meghalaya",
  }),
  D({
    slug: "shillong-peak", name: "Shillong Peak", state: "Meghalaya", hero: IMG.shillong, price: 3999,
    blurb: "Meghalaya's highest viewpoint — the whole city at your feet and clouds rolling across the Khasi hills.",
    best: "All year", duration: "Half Day",
    attractions: ["Main viewpoint deck", "City panorama", "Sunset point"],
    todo: ["Panorama photography", "Sunset visit", "Coffee at the deck"],
    itinerary: [
      { day: 1, title: "Peak evening", desc: "Pickup post-lunch, drive to the peak for sunset, coffee, return." },
    ],
    nearby: ["Elephant Falls", "Shillong", "Mawphlang"],
    gallery: [IMG.shillong, IMG.hills, IMG.forest, IMG.lake],
    mapQuery: "Shillong Peak, Meghalaya",
  }),
  D({
    slug: "elephant-falls", name: "Elephant Falls", state: "Meghalaya", hero: IMG.weisawdong, price: 3499,
    blurb: "Three tiers tumbling through forested rock, a short walk from the road — Shillong's most loved waterfall.",
    best: "All year", duration: "Half Day",
    attractions: ["Three-tier viewpoint", "Boardwalk", "Forest walk"],
    todo: ["Boardwalk photography", "Picnic by the falls"],
    itinerary: [
      { day: 1, title: "Falls morning", desc: "Drive from Shillong, falls, lunch in the city." },
    ],
    nearby: ["Shillong Peak", "Shillong", "Mawphlang"],
    gallery: [IMG.weisawdong, IMG.shillong, IMG.hills, IMG.forest],
    mapQuery: "Elephant Falls, Shillong, Meghalaya",
  }),
  D({
    slug: "wards-lake", name: "Ward's Lake", state: "Meghalaya", hero: IMG.lake, price: 2999,
    blurb: "A horse-shoe lake in the middle of Shillong with a footbridge, paddle boats and old-world cafés around the edge.",
    best: "All year", duration: "Half Day",
    attractions: ["Lakeside walk", "Paddle boats", "Old footbridge"],
    todo: ["Boating", "Café-hop", "Sunset photography"],
    itinerary: [
      { day: 1, title: "Lakeside leisure", desc: "Walk in from Police Bazaar, boating, café break, evening stroll." },
    ],
    nearby: ["Police Bazaar", "Cathedral", "Don Bosco Museum"],
    gallery: [IMG.lake, IMG.shillong, IMG.market, IMG.hills],
    mapQuery: "Ward's Lake, Shillong, Meghalaya",
  }),
  D({
    slug: "police-bazaar", name: "Police Bazaar", state: "Meghalaya", hero: IMG.market, price: 2999,
    blurb: "Shillong's beating heart — momos, vintage record stores, Khasi street fashion and live music tucked above shops.",
    best: "All year", duration: "Half Day",
    attractions: ["Street food trail", "Vintage stores", "Local crafts"],
    todo: ["Khasi food walk", "Souvenir shopping", "Live music gig"],
    itinerary: [
      { day: 1, title: "Bazaar evening", desc: "Walk in from your stay, street food trail, café-hop, live music." },
    ],
    nearby: ["Ward's Lake", "Laitumkhrah", "Shillong"],
    gallery: [IMG.market, IMG.shillong, IMG.hills, IMG.lake],
    mapQuery: "Police Bazaar, Shillong, Meghalaya",
  }),

  // ============ ASSAM ============
  D({
    slug: "kaziranga", name: "Kaziranga National Park", state: "Assam", hero: IMG.kaziranga, price: 11999,
    blurb: "UNESCO grasslands and the world's largest population of the one-horned rhinoceros — plus tigers, elephants and birds.",
    best: "November – April", duration: "2 Days", packageIds: ["meg-assam-7", "ne-10"],
    attractions: ["Central range safari", "Western range safari", "Eastern range safari", "Orchid Park"],
    todo: ["Jeep safari", "Elephant safari", "Birding walk", "Tea estate visit"],
    itinerary: [
      { day: 1, title: "Arrival & evening safari", desc: "Pickup from Guwahati/Jorhat, lodge check-in, central range jeep safari." },
      { day: 2, title: "Dawn elephant safari", desc: "Sunrise elephant safari, western range jeep safari, return drive." },
    ],
    nearby: ["Majuli", "Jorhat", "Tezpur"],
    gallery: [IMG.kaziranga, IMG.forest, IMG.guwahati, IMG.river, IMG.hills],
    mapQuery: "Kaziranga National Park, Assam",
  }),
  D({
    slug: "majuli", name: "Majuli", state: "Assam", hero: IMG.majuli, price: 9999,
    blurb: "The world's largest river island — Satras, mask-makers, mustard fields and the slow rhythm of the Brahmaputra.",
    best: "October – March", duration: "2 Days", packageIds: ["meg-assam-7", "ne-10"],
    attractions: ["Auniati Satra", "Kamalabari Satra", "Samaguri mask studio", "Bird sanctuary"],
    todo: ["Visit a Satra", "Mask making workshop", "Cycle the island", "Sunset over the river"],
    itinerary: [
      { day: 1, title: "Onto the island", desc: "Ferry from Nimati Ghat, check-in, Satra visit, mask studio, river sunset." },
      { day: 2, title: "Slow morning", desc: "Cycle ride, birding, lunch with a family, ferry back." },
    ],
    nearby: ["Jorhat", "Kaziranga", "Sivasagar"],
    gallery: [IMG.majuli, IMG.river, IMG.forest, IMG.guwahati],
    mapQuery: "Majuli, Assam",
  }),
  D({
    slug: "guwahati", name: "Guwahati", state: "Assam", hero: IMG.guwahati, price: 5999,
    blurb: "The gateway to the North East — Brahmaputra cruises at sunset, ancient temples and the best Assamese thalis on the Mall.",
    best: "All year", duration: "1 – 2 Days", packageIds: ["meg-assam-7", "ne-10", "ne-15"],
    attractions: ["Kamakhya Temple", "Umananda Island", "Assam State Museum", "Brahmaputra River cruise"],
    todo: ["Evening river cruise", "Old quarter food walk", "Temple-hop", "Tea-shop morning"],
    itinerary: [
      { day: 1, title: "Temple & river", desc: "Airport pickup, Kamakhya, Umananda island, sunset cruise on the Brahmaputra." },
      { day: 2, title: "Heritage walk", desc: "Assam State Museum, old quarter walk, Fancy Bazaar, depart." },
    ],
    nearby: ["Pobitora", "Shillong", "Kaziranga"],
    gallery: [IMG.guwahati, IMG.river, IMG.kamakhya, IMG.market],
    mapQuery: "Guwahati, Assam",
  }),
  D({
    slug: "kamakhya", name: "Kamakhya Temple", state: "Assam", hero: IMG.kamakhya, price: 3999,
    blurb: "One of India's most venerated Shakti Peethas, perched on Nilachal Hill above the Brahmaputra.",
    best: "All year", duration: "Half Day", packageIds: ["meg-assam-7", "ne-10"],
    attractions: ["Main temple", "Nilachal Hill viewpoint", "Surrounding shrines"],
    todo: ["Temple darshan", "Hilltop photography", "Local prasad lunch"],
    itinerary: [
      { day: 1, title: "Temple morning", desc: "Early drive up Nilachal Hill, darshan, viewpoints, return for late breakfast." },
    ],
    nearby: ["Guwahati", "Umananda", "Pobitora"],
    gallery: [IMG.kamakhya, IMG.guwahati, IMG.river, IMG.hills],
    mapQuery: "Kamakhya Temple, Guwahati, Assam",
  }),
  D({
    slug: "pobitora", name: "Pobitora Wildlife Sanctuary", state: "Assam", hero: IMG.pobitora, price: 5499,
    blurb: "Highest rhino density per sq.km in the world — an easy weekend safari just 50 km from Guwahati.",
    best: "November – April", duration: "1 Day", packageIds: ["meg-assam-7", "ne-10"],
    attractions: ["Pobitora safari zone", "Rajamayong Hill", "Birding boardwalk"],
    todo: ["Jeep safari", "Elephant safari", "Birdwatching", "Sunset at Rajamayong"],
    itinerary: [
      { day: 1, title: "Safari day-trip", desc: "Early drive from Guwahati, morning safari, lunch, return by evening." },
    ],
    nearby: ["Guwahati", "Kaziranga", "Manas"],
    gallery: [IMG.pobitora, IMG.kaziranga, IMG.forest, IMG.guwahati],
    mapQuery: "Pobitora Wildlife Sanctuary, Assam",
  }),
  D({
    slug: "manas", name: "Manas National Park", state: "Assam", hero: IMG.manas, price: 12999,
    blurb: "A tiger reserve along the Bhutan border — elephants, pygmy hogs, golden langurs and the wild Manas river.",
    best: "November – March", duration: "2 Days", packageIds: ["ne-10", "ne-15"],
    attractions: ["Bansbari range", "Mathanguri", "River rafting stretch", "Watchtower trail"],
    todo: ["Tiger safari", "Manas river rafting", "Birding", "Border viewpoint"],
    itinerary: [
      { day: 1, title: "Arrival & afternoon safari", desc: "Drive in from Guwahati, lodge check-in, afternoon jeep safari." },
      { day: 2, title: "River & return", desc: "Morning rafting, lunch in Bansbari, return drive." },
    ],
    nearby: ["Bhutan border", "Guwahati", "Pobitora"],
    gallery: [IMG.manas, IMG.forest, IMG.river, IMG.guwahati],
    mapQuery: "Manas National Park, Assam",
  }),
  D({
    slug: "haflong", name: "Haflong", state: "Assam", hero: IMG.haflong, price: 7999,
    blurb: "Assam's only hill station — a quiet lake, orchid hills and the mysterious bird phenomenon of nearby Jatinga.",
    best: "October – May", duration: "2 Days", packageIds: ["ne-10", "ne-15"],
    attractions: ["Haflong Lake", "Jatinga viewpoint", "Maibang ruins", "Borail hills"],
    todo: ["Lake walk", "Jatinga night phenomenon", "Maibang heritage drive"],
    itinerary: [
      { day: 1, title: "Hill arrival", desc: "Drive in from Guwahati, lake walk, sunset at viewpoint." },
      { day: 2, title: "Heritage day", desc: "Maibang ruins, Jatinga, drive back." },
    ],
    nearby: ["Jatinga", "Maibang", "Silchar"],
    gallery: [IMG.haflong, IMG.lake, IMG.hills, IMG.forest],
    mapQuery: "Haflong, Assam",
  }),
  D({
    slug: "sivasagar", name: "Sivasagar", state: "Assam", hero: IMG.sivasagar, price: 6499,
    blurb: "The old Ahom capital — palaces, tank-temples and brick monuments that ruled upper Assam for 600 years.",
    best: "October – March", duration: "1 Day", packageIds: ["ne-10", "ne-15"],
    attractions: ["Rang Ghar", "Talatal Ghar", "Sivadol Temple", "Sivasagar Tank"],
    todo: ["Heritage walk", "Photography", "Tea-estate side trip"],
    itinerary: [
      { day: 1, title: "Ahom day", desc: "Drive from Jorhat / Kaziranga, Rang Ghar, Talatal Ghar, Sivadol, return." },
    ],
    nearby: ["Jorhat", "Majuli", "Kaziranga"],
    gallery: [IMG.sivasagar, IMG.kaziranga, IMG.majuli, IMG.forest],
    mapQuery: "Sivasagar, Assam",
  }),

  // ============ ARUNACHAL ============
  D({
    slug: "tawang", name: "Tawang", state: "Arunachal Pradesh", hero: IMG.tawang, price: 18999,
    blurb: "India's largest monastery at 10,000 ft — and the road there is one of the most spectacular drives in the country.",
    best: "March – October", duration: "3 Days", packageIds: ["ne-10", "ne-15"],
    attractions: ["Tawang Monastery", "Madhuri Lake", "Bumla Pass", "PT Tso lake", "Tawang War Memorial"],
    todo: ["Visit the monastery", "Drive to Madhuri Lake", "Bumla Pass border drive", "Buddhist heritage walk"],
    itinerary: [
      { day: 1, title: "Climb to Tawang", desc: "Dirang to Tawang via Sela Pass and Jaswant Garh." },
      { day: 2, title: "Monastery + Madhuri", desc: "Tawang monastery, town walk, drive to Madhuri Lake." },
      { day: 3, title: "Bumla", desc: "Permit drive to Bumla Pass and PT Tso, return to Dirang." },
    ],
    nearby: ["Sela Pass", "Dirang", "Bomdila"],
    gallery: [IMG.tawang, IMG.monastery, IMG.selapass, IMG.hills, IMG.forest],
    mapQuery: "Tawang, Arunachal Pradesh",
  }),
  D({
    slug: "dirang", name: "Dirang", state: "Arunachal Pradesh", hero: IMG.dirang, price: 9999,
    blurb: "Kiwi farms, hot springs, a tiny medieval fort and the warmest mid-stop on the road to Tawang.",
    best: "March – October", duration: "1 – 2 Days", packageIds: ["ne-10", "ne-15"],
    attractions: ["Sangti Valley", "Hot springs", "Dirang Dzong", "Kiwi orchards"],
    todo: ["Sangti valley drive", "Hot-spring soak", "Kiwi-farm visit"],
    itinerary: [
      { day: 1, title: "Valley arrival", desc: "Drive in from Bomdila, Dzong walk, evening at hot springs." },
      { day: 2, title: "Sangti morning", desc: "Sangti valley drive, kiwi farm, lunch and onward to Tawang." },
    ],
    nearby: ["Bomdila", "Sela Pass", "Tawang"],
    gallery: [IMG.dirang, IMG.hills, IMG.forest, IMG.tawang],
    mapQuery: "Dirang, Arunachal Pradesh",
  }),
  D({
    slug: "bomdila", name: "Bomdila", state: "Arunachal Pradesh", hero: IMG.bomdila, price: 8499,
    blurb: "Apple orchards, gompas and the first big snow-capped views as you climb out of the Assam plains.",
    best: "April – October", duration: "2 Days", packageIds: ["ne-10", "ne-15"],
    attractions: ["Bomdila Monastery", "Eaglenest birding", "Apple orchards", "Bomdila viewpoint"],
    todo: ["Monastery visit", "Bird sanctuary drive", "Orchard walk"],
    itinerary: [
      { day: 1, title: "First gompa", desc: "Drive in from Tezpur, monastery, viewpoints, dinner with a local host." },
      { day: 2, title: "Onward", desc: "Eaglenest morning, drive to Dirang." },
    ],
    nearby: ["Dirang", "Tawang", "Sela Pass"],
    gallery: [IMG.bomdila, IMG.tawang, IMG.hills, IMG.forest],
    mapQuery: "Bomdila, Arunachal Pradesh",
  }),
  D({
    slug: "ziro", name: "Ziro Valley", state: "Arunachal Pradesh", hero: IMG.ziro, price: 11999,
    blurb: "Apatani paddy-fish fields, pine forests and the country's most loved indie music festival every September.",
    best: "March – October", duration: "3 Days", packageIds: ["ne-10", "ne-15"],
    attractions: ["Apatani villages", "Talley Valley", "Ziro Festival", "Dolo Mando viewpoint"],
    todo: ["Apatani homestay", "Pine forest walks", "Music festival (Sep)", "Trek to Talley"],
    itinerary: [
      { day: 1, title: "Into Ziro", desc: "Drive from Itanagar, valley arrival, homestay check-in, village walk." },
      { day: 2, title: "Apatani & pines", desc: "Apatani culture day, Dolo Mando viewpoint, sunset over the valley." },
      { day: 3, title: "Talley", desc: "Short Talley Valley trek, return to Itanagar." },
    ],
    nearby: ["Itanagar", "Daporijo", "Mechuka"],
    gallery: [IMG.ziro, IMG.forest, IMG.hills, IMG.tawang],
    mapQuery: "Ziro Valley, Arunachal Pradesh",
  }),
  D({
    slug: "mechuka", name: "Mechuka", state: "Arunachal Pradesh", hero: IMG.mechuka, price: 16999,
    blurb: "Hidden Shangri-La 29 km from the McMahon line — yak meadows, Buddhist gompas and almost no signal.",
    best: "April – October", duration: "3 Days", packageIds: ["ne-15"],
    attractions: ["Samten Yongcha Monastery", "Yargyap Chu river", "Yak grazing meadows", "Hanuman Tok"],
    todo: ["Monastery visit", "Riverside picnic", "Meadow trek", "Stargazing"],
    itinerary: [
      { day: 1, title: "Long drive in", desc: "Drive in from Aalo, monastery, sunset by the river." },
      { day: 2, title: "Meadows", desc: "Yak meadows, viewpoint, local lunch." },
      { day: 3, title: "Return", desc: "Morning at the river, drive out." },
    ],
    nearby: ["Aalo", "Yingkiong", "Ziro"],
    gallery: [IMG.mechuka, IMG.hills, IMG.forest, IMG.river],
    mapQuery: "Mechuka, Arunachal Pradesh",
  }),
  D({
    slug: "sela-pass", name: "Sela Pass", state: "Arunachal Pradesh", hero: IMG.selapass, price: 7999,
    blurb: "Snow-rimmed pass at 13,700 ft, dotted with 101 sacred lakes — the gateway to Tawang.",
    best: "April – October", duration: "1 Day", packageIds: ["ne-10", "ne-15"],
    attractions: ["Sela Lake", "Jaswant Garh", "Snow point", "Paradise Lake"],
    todo: ["Photography on the pass", "Snow play (winter)", "Tea at Jaswant Garh"],
    itinerary: [
      { day: 1, title: "Pass day", desc: "Drive Dirang → Sela Pass → Jaswant Garh → Tawang." },
    ],
    nearby: ["Tawang", "Dirang", "Bomdila"],
    gallery: [IMG.selapass, IMG.tawang, IMG.hills, IMG.forest],
    mapQuery: "Sela Pass, Arunachal Pradesh",
  }),
  D({
    slug: "namdapha", name: "Namdapha National Park", state: "Arunachal Pradesh", hero: IMG.namdapha, price: 17999,
    blurb: "The only park in the world with four big cats — and a true rainforest in the foothills of the Eastern Himalayas.",
    best: "October – March", duration: "3 Days", packageIds: ["ne-15"],
    attractions: ["Deban range", "Hornbill nests", "Noa-Dihing river", "Tropical rainforest trails"],
    todo: ["Jungle trek", "Birding (hornbills)", "Camp by the river"],
    itinerary: [
      { day: 1, title: "Deban arrival", desc: "Drive in from Miao, lodge check-in, evening walk." },
      { day: 2, title: "Deep forest", desc: "Full-day jungle trek, riverside lunch." },
      { day: 3, title: "Birding return", desc: "Hornbill morning, drive out." },
    ],
    nearby: ["Miao", "Roing", "Aalo"],
    gallery: [IMG.namdapha, IMG.forest, IMG.river, IMG.hills],
    mapQuery: "Namdapha National Park, Arunachal Pradesh",
  }),
];

export const DESTINATION_STATES = ["All", "Meghalaya", "Assam", "Arunachal Pradesh"];

export const getDestinationBySlug = (slug) =>
  DESTINATIONS.find((d) => d.slug === slug) || null;
